import "core-js/modules/es.number.constructor.js";
//
//
//
//
//
//
//
//
//
//
//
//

import LazyImage from './LazyImage';
export default {
  name: 'group-entrance',
  components: {
    'v-lazy-image': LazyImage
  },
  props: {
    name: String,
    postUrl: String,
    link: String,
    salePrice: Number,
    originPrice: Number,
    saleCount: Number
  },
  methods: {
    onGroupClick: function onGroupClick() {
      location.href = this.link;
    }
  }
};